<mat-form-field
        appearance="outline"
        [formGroup]="formGroup"
        style="margin-bottom: -1.25em; width: 100%;">
    <mat-label>{{config.label}} {{requerido ? '*' : ''}}</mat-label>
    <input matInput
           type="text"
           [placeholder]="config.placeholder || ''"
           [value]="valorFormatado"
           (input)="onInput($event)"
           [readonly]="config.readonly"
           maxlength="18" />
</mat-form-field>